'use client'

import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const paddings = { none: '', sm: 'p-3', md: 'p-4', lg: 'p-5' }

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ padding = 'none', className, style, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('rounded-[var(--radius-lg)]', paddings[padding], className)}
      style={{
        background: 'var(--surface-primary)',
        border: '1px solid var(--border-default)',
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  ),
)
Card.displayName = 'Card'

export interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  action?: React.ReactNode
}

export const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>(
  ({ action, className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center justify-between px-5 h-11', className)}
      style={{ borderBottom: '1px solid var(--border-muted)' }}
      {...props}
    >
      <span className="text-[13px] font-medium" style={{ color: 'var(--text-primary)' }}>
        {children}
      </span>
      {action}
    </div>
  ),
)
CardHeader.displayName = 'CardHeader'
